import React from 'react'
import { X } from 'lucide-react'
import styles from './styles.module.scss'

interface ClearInputButtonProps {
    label: string
    onClear: () => void
}

// Small "x" inside the right edge of a text field that empties it.
const ClearInputButton: React.FC<ClearInputButtonProps> = ({ label, onClear }) => (
    <button
        type="button"
        className={styles.clearButton}
        aria-label={`Clear ${label}`}
        // Keep focus in the field so clearing doesn't count as leaving it
        onMouseDown={(e) => e.preventDefault()}
        onClick={onClear}
    >
        <X size={16} strokeWidth={2.5} />
    </button>
)

export default ClearInputButton
